import { Input } from 'antd'
import { SearchProps } from 'antd/es/input'
import classnames from 'classnames'
import { ChangeEvent } from 'react'

import { useLocales } from 'src/locales'

import { useStyles } from './styles'

const { Search } = Input

type Props = {
  onSearch: (value: string) => void
  maxWidth?: number
} & SearchProps

export const SearchBar = ({ maxWidth, onSearch, ...rest }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles({ maxWidth })

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) onSearch('')
  }

  return (
    <Search
      allowClear
      placeholder={rest.placeholder ?? t('common.search')}
      onSearch={onSearch}
      onChange={onChange}
      className={classnames(styles.searchBlock, rest.className)}
      enterButton
      {...rest}
    />
  )
}
